import type { AppData } from '@modules/root/page/AppPage';

const getShowProfessionalArchiproConnectBanner = (user: AppData['user']) => {
    if (user.__typename === 'Guest') return true;
    if (user.IsArchiproStaff) return false;
    return !user.Professionals.find((p) => p.IsManufacturer);
};

export default getShowProfessionalArchiproConnectBanner;
